/* eslint-disable no-nested-ternary */
const React = require('react');
const PropTypes = require('prop-types');
const Hotjar = require('nordic/hotjar');

function HotjarScript(props) {
  const { siteId } = props;

  return (
    <>
      <Hotjar siteId={siteId} traffic={{ from: 0, to: 100 }} />
    </>
  );
}

HotjarScript.propTypes = {
  siteId: PropTypes.string.isRequired,
};

module.exports = HotjarScript;
